import React from 'react';
import { useSeo } from '@/lib/seo';
import FeedbackForm from '@/components/feedback/FeedbackForm';

export default function Feedback() {
  const urlParams = new URLSearchParams(window.location.search);
  const bookingRef = urlParams.get('booking') || '';
  const experience = urlParams.get('experience') || '';

  useSeo({
    title: 'Experience Feedback — Motion Reality',
    description:
      'Share your sim racing experience feedback and enter our monthly draw for a complimentary one-hour Sim Racing Experience at Motion Reality.',
  });

  return (
    <div className="min-h-screen bg-[#0d0d0f] pt-16">
      <section className="py-14 px-6 lg:px-10 border-b border-white/5">
        <div className="max-w-3xl mx-auto">
          <p className="text-primary text-xs font-bold tracking-widest mb-3">POST-EXPERIENCE FEEDBACK</p>
          <h1 className="text-white font-black text-3xl md:text-5xl uppercase leading-tight">
            How Was Your Session?
          </h1>
          <div className="mt-5 max-w-xl text-sm text-white/50 leading-relaxed space-y-3">
            <p className="text-white/80 font-medium">Would you like to win a free one-hour session?</p>
            <p>Simply complete the feedback form below and you&rsquo;ll be entered into our monthly draw for a complimentary Sim Racing Experience.</p>
            <p>Thanks so much for attending your session with us — we hope you had an awesome time behind the wheel!</p>
            <p>We&rsquo;re always looking to improve, and we&rsquo;d really appreciate your honest feedback. What did we do well, and what could make the experience even better next time? Your insights help us continue delivering the most immersive and realistic sim racing sessions in the UK.</p>
            <p className="text-white/40">Thanks again,<br />The Motion Reality Team</p>
          </div>
        </div>
      </section>

      <section className="py-12 px-6 lg:px-10">
        <div className="max-w-3xl mx-auto">
          <FeedbackForm initialBookingRef={bookingRef} initialExperience={experience} />
        </div>
      </section>
    </div>
  );
}